enum Authority {
  /**
   * SYSTEM AUTHORITIES are those assigned to PERSONATECH team
   */

  PLATFORM_CONFIG_WRITE = "PLATFORM_CONFIG_WRITE",
  PLATFORM_CONFIG_READ = "PLATFORM_CONFIG_READ",
  PLATFORM_USER_WRITE = "PLATFORM_USER_WRITE",
  PLATFORM_USER_READ = "PLATFORM_USER_READ",
  PLATFORM_CLIENT_WRITE = "PLATFORM_CLIENT_WRITE",
  PLATFORM_CLIENT_READ = "PLATFORM_CLIENT_READ",
  PLATFORM_EVENT_SERIES_CREATE = "PLATFORM_EVENT_SERIES_CREATE",

  /**
   * CLIENT AUTHORITIES are those assigned at Client level
   */

  EVENT_SERIES_WRITE = "EVENT_SERIES_WRITE",
  EVENT_SERIES_READ = "EVENT_SERIES_READ",
  EVENT_SERIES_USER_WRITE = "EVENT_SERIES_USER_WRITE",
  EVENT_SERIES_USER_READ = "EVENT_SERIES_USER_READ",
  REGISTRATION_CREATE = "REGISTRATION_CREATE",
  REGISTRATION_WRITE = "REGISTRATION_WRITE",
  REGISTRATION_READ = "REGISTRATION_READ",
  EVENT_CREATE = "EVENT_CREATE",
  EVENT_WRITE = "EVENT_WRITE",
  EVENT_READ = "EVENT_READ",
  PROGRAM_CREATE = "PROGRAM_CREATE",
  PROGRAM_WRITE = "PROGRAM_WRITE",
  PROGRAM_READ = "PROGRAM_READ",
  FINANCE_READ = "FINANCE_READ"
}

export default Authority;
